module.exports = __webpack_public_path__ + "img/wallpaper-anans.d0064343.png";